export default __webpack_public_path__ + "static/2-10063de6144d5182cc6c8640a81d094e.png";